"use strict";

import Page from "./Payout.jsx";

export const auth = true;
export const title = "i18n:payout.pageTitleLoading";
export const Component = Page;
